import React from 'react';
import styled, { keyframes } from 'styled-components';

const fontColorLight = '#E9E8E8';
const fontColorDark = '#113';

const LoaderProgressDiv = styled.div<{ $isDark?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 7.4vh;

    span {
        font-size: 14px;
        color: ${({ $isDark }) => ($isDark ? fontColorDark : fontColorLight)};
    }
`;

const LoaderIconAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderIcon = styled.div<{ $isDark?: boolean }>`
    display: inline-block;
    position: relative;
    width: 27px;
    height: 27px;
    margin-right: 10px;
    border: 3px solid ${({ $isDark }) => ($isDark ? fontColorDark : fontColorLight)};
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: ${LoaderIconAnimation} 1s linear infinite;
`;

interface LoaderProgreessProps {
    isDark?: boolean;
}

export const LoaderProgress = ({ isDark }: LoaderProgreessProps) => {
    return (
        <LoaderProgressDiv $isDark={isDark}>
            <LoaderIcon $isDark={isDark} />
            <span>Loading...</span>
        </LoaderProgressDiv>
    );
};
